import React, { useLayoutEffect } from 'react'
import { Calendar } from 'primereact/calendar'

const CalendarEditor = ({ options, validationErrors }) => {
    const rowIndex = options.rowIndex

    useLayoutEffect(() => {
        if (options.rowData?._editKey !== undefined) {
            options.editorCallback(null)
        }
    }, [])

    return (
        <Calendar
            value={options.value}
            onChange={(e) => options.editorCallback(e.target.value)}
            showTime={false}
            dateFormat="dd/mm/yy"
            className={validationErrors[rowIndex] && validationErrors[rowIndex][options.field] ? 'p-invalid' : ''}/>
    )
}

export default CalendarEditor
